module.exports = __webpack_public_path__ + "static/img/kb-logo.42467dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kb-logo.png
// module id = 8ppt
// module chunks = 1